import React from 'react'
import { Link } from 'react-router-dom'
import { ToolkitPageLayout } from '../../../components'
import {
  EchoInfoImage,
  EchoFlyerJhhScdImage,
  EchoFlyerSapportImage,
  EchoFlyerCboImage,
  EchoSessionsListImage
} from 'assets'

// TODO: Import images from assets if any

export const ClinicsEchoPage: React.FC = () => {
  // TODO: Get content from plans/toolkit_content.json for "Extension for Community Health Outcomes" (Clinics, page_id=275)
  // TODO: Convert HTML to JSX
  // TODO: Import and use images

  return (
    <ToolkitPageLayout
      title="Extension for Community Health Outcomes (ECHO) - Clinics"
      breadcrumbs={[
        { label: 'Toolkit', path: '/toolkit' },
        { label: 'Clinics', path: '/toolkit/clinics' },
        {
          label: 'ECHO',
          path: '/toolkit/clinics/echo'
        }
      ]}
    >
      <div className="prose max-w-none text-[#3C2416]">
        <p className="text-lg italic mb-8">
          Project ECHO is a guided practice model designed to provide
          best-practice specialty care and reduce health disparities by
          connecting providers with specialists through ongoing interactive,
          telementoring sessions.
        </p>

        <hr className="my-8" />

        <h2 className="text-2xl font-semibold underline text-[#142841] mt-8 mb-6">
          Instructions:
        </h2>
        <p className="text-lg mb-4">
          — Join ECHO! More information linked below:
        </p>

        <div className="space-y-6 mb-8">
          <a
            href="https://www.hopkinsmedicine.org/medicine/sickle"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Learn more about Johns Hopkins Medicine Sickle Cell ECHO for providers"
            className="block hover:shadow-xl transition-shadow duration-300 border border-gray-200 rounded-lg p-2 bg-white"
          >
            <img
              src={EchoInfoImage}
              alt="Johns Hopkins Medicine Sickle Cell ECHO information for providers"
              className="rounded-md shadow-sm mx-auto w-full max-w-2xl object-contain"
            />
          </a>

          <a
            href="https://docs.google.com/document/d/e/2PACX-1vQyknsvXpV3JL2QwUjub4cmjIngMMNWXweIjVbw7tiLwZN3Mp-vR5H5YLWnLLtkxvrhhhegyQUYVL_f/pub"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="View the POWER Project ECHO flyer"
            className="block hover:shadow-xl transition-shadow duration-300 border border-gray-200 rounded-lg p-2 bg-white"
          >
            <img
              src={EchoFlyerCboImage}
              alt="POWER Project ECHO flyer"
              className="rounded-md shadow-sm mx-auto w-full max-w-2xl object-contain"
            />
          </a>
        </div>

        <p className="text-lg mb-2">
          <span className="underline">Community Health Workers</span>: Click{' '}
          <a
            href="https://sicklecelldisease.net/power-project/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#A6410A] hover:text-[#894d35] underline"
          >
            here
          </a>
          .
        </p>
        <p className="text-lg mb-2">
          <span className="underline">All Providers</span>:{' '}
          <em>Johns Hopkins Sickle Cell Disease ECHO</em> is hosted every
          Wednesday, 1:00 p.m. EST.
        </p>
        <p className="text-lg mb-4">
          <span className="underline">Advanced Practice Providers</span>:{' '}
          <em>SAPPORT ECHO</em> is hosted every first Tuesday, 8:00 a.m. CST /
          9:00 a.m. EST and every third Thursday, 12:00 p.m. EST.
        </p>

        <h4 className="text-xl font-semibold mt-6 mb-3">
          Choose flyer below for more information:
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <a
            href="https://docs.google.com/document/d/e/2PACX-1vT_1wJgth_GIBXdlKXmiszH6Kg41wiBSsR3xgBsUV21c2BLyBFtsYj0qnh1f5dpoD5Iog49cgQA9iHR/pub"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Johns Hopkins SCD ECHO Flyer"
            className="block hover:shadow-xl transition-shadow duration-300 border border-gray-200 rounded-lg p-2 bg-white"
          >
            <img
              src={EchoFlyerJhhScdImage}
              alt="Johns Hopkins SCD ECHO Flyer"
              className="rounded-md shadow-sm w-full h-auto object-contain"
            />
          </a>
          <a
            href="https://docs.google.com/document/d/e/2PACX-1vSFCfP3AALYX4ppfzxv-ZOLjA-70zQgqK5gb8vKj_qXidgfHjLccFZbV7xrgjP9gS3lL8bMiqW6mm4L/pub"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="SAPPORT ECHO Flyer"
            className="block hover:shadow-xl transition-shadow duration-300 border border-gray-200 rounded-lg p-2 bg-white"
          >
            <img
              src={EchoFlyerSapportImage}
              alt="SAPPORT ECHO Flyer"
              className="rounded-md shadow-sm w-full h-auto object-contain"
            />
          </a>
          <a
            href="https://docs.google.com/document/d/e/2PACX-1vQoOza5TWkw8RTwRcQucnqBhUJEos7bWDIiMY05qQ5S5NMHHvpzN0bMs9-agx1PVfA-oOHnWHP-4vWh/pub"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Community Based Organizations ECHO Flyer"
            className="block hover:shadow-xl transition-shadow duration-300 border border-gray-200 rounded-lg p-2 bg-white"
          >
            <img
              src={EchoFlyerCboImage}
              alt="CBO ECHO Flyer"
              className="rounded-md shadow-sm w-full h-auto object-contain"
            />
          </a>
        </div>

        <div className="mb-8 p-4 border border-gray-200 rounded-lg shadow-md bg-white">
          <h3 className="text-xl font-semibold text-[#142841] mb-3">
            List of ECHO Sessions
          </h3>
          <img
            src={EchoSessionsListImage}
            alt="List of ECHO Sessions"
            className="rounded-md shadow-sm mx-auto w-full max-w-3xl object-contain"
          />
        </div>

        <p className="text-base mb-6">
          <em>
            For more information or to register to attend, contact:
            <a
              href="mailto:sinerge@jhmi.edu"
              className="text-[#A6410A] hover:text-[#894d35] underline ml-1"
            >
              sinerge@jhmi.edu
            </a>{' '}
            or 443-287-0608.
          </em>
        </p>

        <h2 className="text-2xl font-semibold text-[#142841] mt-8 mb-6 text-center">
          Infusion Center Specific ECHO Session
        </h2>
        <div className="mb-8 text-center">
          <a
            href="https://drive.google.com/drive/folders/143hV11VqkIBGJYlLTUkh796pdY4e_vjG"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-[#713d43] hover:bg-[#5a3135] text-white rounded-md px-6 py-3 text-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
          >
            Click Here
          </a>
        </div>

        <hr className="my-12" />

        <div className="mt-12 mb-8 text-center">
          <Link
            to="/toolkit/clinics"
            className="bg-[#A6410A] hover:bg-[#894d35] text-white rounded-md px-6 py-3 text-lg font-medium transition-colors duration-200 shadow-md hover:shadow-lg"
          >
            All done? Click here to return to the Clinics screen
          </Link>
        </div>
      </div>
    </ToolkitPageLayout>
  )
}
